import { Controller } from "@hotwired/stimulus";

/**
 * ボタン選択永続化バグ対策 controller
 * ページロード時に head にスタイルとスクリプトを挿入して、
 * ボタンの長押し選択やコンテキストメニューを防止する
 */
export default class extends Controller {
  querySelector = "button, input[type=\"button\"], input[type=\"submit\"], .btn, .button";

  connect() {
    this.injectStyles();
    this.injectScript();
  }

  disconnect() {
    this.removeEventListeners();
  }

  injectStyles() {
    const style = document.createElement("style");
    style.setAttribute("data-button-selection-prevention", "");
    style.textContent = `
      button,
      button *,
      input[type="button"],
      input[type="submit"],
      .btn,
      .button {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
        -webkit-touch-callout: none !important;
        touch-action: manipulation !important;
        -webkit-tap-highlight-color: transparent !important;
        cursor: pointer;
      }
    `;
    document.head.appendChild(style);
  }

  clearSelection = () => {
    const sel = window.getSelection();
    if (sel) {
      if (sel.removeAllRanges) sel.removeAllRanges();
      if (sel.empty) sel.empty();
    }
  };

  handleContextMenu = (e) => {
    if (e.target.closest(this.querySelector)) e.preventDefault();
  };

  handleTouchStart = (e) => {
    if (e.target.closest(this.querySelector)) this.clearSelection();
  };

  injectScript() {
    // コンテキストメニューとタッチ選択を防止
    document.addEventListener("contextmenu", this.handleContextMenu, { capture: true });

    // タッチ開始時に選択をクリア
    document.addEventListener("touchstart", this.handleTouchStart, { passive: true });

    // ページ読み込み時に選択をクリア
    window.addEventListener("load", this.clearSelection);

    // スクリプト読み込み時に即座に選択をクリア
    this.clearSelection();
  }

  removeEventListeners() {
    document.removeEventListener("contextmenu", this.handleContextMenu, { capture: true });
    document.removeEventListener("touchstart", this.handleTouchStart, { passive: true });
    window.removeEventListener("load", this.clearSelection);

    // 注入したスタイルを削除
    const style = document.head.querySelector("[data-button-selection-prevention]");
    if (style) {
      style.remove();
    }
  }
}
